export default "__VITE_ASSET__DK_vCaiG__"